import React from 'react'
import { t } from 'ttag'

class PermissionModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      userName: ''
    }
  }

  render = () => (
    <div>
      <div className="form-group">
        <label className="sr-only">Username</label>
        <div className="input-group">
          <input
            type="text"
            className="form-control"
            value={this.state.userName}
            onChange={t => {
              this.setState({
                ...this.state,
                userName: t.target.value
              })
            }}
          />
          <div className="input-group-btn">
            <input
              type="button"
              className="btn btn-success no-style"
              onClick={() =>
                this.props.onAddUser(this.state.userName).then(() =>
                  this.setState({
                    ...this.state,
                    userName: ''
                  })
                )}
              value={t`Add User`}
            />
          </div>
        </div>
      </div>
      <table className="table tbl">
        <thead>
          <tr>
            <th>{t`Name`}</th>
            <th>{t`Can Administer`}</th>
            <th>{t`Can Edit`}</th>
            <th>{t`Reporting`}</th>
            <th>{t`Notifications`}</th>
            <th>{t`RSVP`}</th>
            <th>{t`Actions`}</th>
          </tr>
        </thead>
        <tbody>
          {this.props.permissions.map((p, idx) => (
            <tr key={p.id} className={idx % 2 === 0 ? 'even' : 'odd'}>
              <td>{p.userName}</td>
              <td>
                <input
                  type="checkbox"
                  disabled={p.inheritedFromParent}
                  onChange={s => {
                    if (!p.inheritedFromParent) {
                      this.props.onToggleUserPermission(
                        p.id,
                        'administer',
                        s.target.checked
                      )
                    }
                  }}
                  name="administer"
                  defaultChecked={p.administer}
                />
              </td>
              <td>
                <input
                  type="checkbox"
                  disabled={p.inheritedFromParent}
                  onChange={s => {
                    if (!p.inheritedFromParent) {
                      this.props.onToggleUserPermission(p.id, 'edit', s.target.checked)
                    }
                  }}
                  name="edit"
                  value={p.edit}
                  defaultChecked={p.edit}
                />
              </td>
              <td>
                <input
                  type="checkbox"
                  disabled={p.inheritedFromParent}
                  onChange={s => {
                    if (!p.inheritedFromParent) {
                      this.props.onToggleUserPermission(
                        p.id,
                        'reporting',
                        s.target.checked
                      )
                    }
                  }}
                  name="reporting"
                  value={p.reporting}
                  defaultChecked={p.reporting}
                />
              </td>
              <td>
                <input
                  type="checkbox"
                  disabled={p.inheritedFromParent}
                  onChange={s => {
                    if (!p.inheritedFromParent) {
                      this.props.onToggleUserPermission(
                        p.id,
                        'notifications',
                        s.target.checked
                      )
                    }
                  }}
                  name="notifications"
                  value={p.notifications}
                  defaultChecked={p.notifications}
                />
              </td>
              <td>
                <input
                  type="checkbox"
                  disabled={p.inheritedFromParent}
                  onChange={s => {
                    if (!p.inheritedFromParent) {
                      this.props.onToggleUserPermission(p.id, 'rsvp', s.target.checked)
                    }
                  }}
                  name="rsvp"
                  value={p.rsvp}
                  defaultChecked={p.rsvp}
                />
              </td>
              <td>
                {!p.inheritedFromParent && (
                  <input
                    type="button"
                    className="btn btn-danger no-style"
                    value="Delete"
                    onClick={() => this.props.onDeletePermission(p.id)}
                  />
                )}{' '}
                {p.inheritedFromParent && (
                  <span
                    style={{
                      fontStyle: 'italic',
                      fontSize: '.8rem'
                    }}>
                    {t`Inherited From Parent`}
                  </span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default PermissionModal
